import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from './views/Login.vue'
import Main from './views/Main.vue'
import gloablConfig from './config.js'
import pageNotFound from './components/404.vue'
import Welcome from './components/Welcome.vue'

Vue.use(VueRouter)

const appRouter = new VueRouter({
	routes:[
		{
			path:'/',
			component:Login,
		},
		{
			path:'/main',
			component:Main,
		},
		{
			path:'/404',
			component:pageNotFound
		},
		{
			path:"*",
			redirect:'/404'
		},
	],
	mode: 'history',
    base: '/meterweb/'
});
appRouter.beforeEach((router,froms,next)=>{
	if (router.matched.length === 0) {
	        next('/404') // 判断此跳转路由的来源路由是否存在，存在的情况跳转到来源路由，否则跳转到404页面
	}else{
		if(gloablConfig.getUserLocal()==null  && router.path !== '/'){
			next({
				path: '/',
			})
		}else{
			next();
		}
	}
})
export default appRouter
